import { createContext, useContext, useState, useCallback } from "react";

const LanguageContext = createContext();

export function useLanguage() {
  return useContext(LanguageContext);
}

export function useT() {
  const { t } = useContext(LanguageContext);
  return t;
}

const translations = {
  de: {
    // Navbar
    nav_home: "Startseite",
    nav_rental: "Fahrzeugvermietung",
    nav_services: "Leistungen",
    nav_contact: "Kontakt",
    nav_cta: "Jetzt mieten",

    // Hero
    hero_holding: "Ein Unternehmen der",
    hero_badge: "Europaweit \u00b7 Zuverlässig \u00b7 Professionell",
    hero_heading: "Wir bringen Ihre Waren pünktlich ans Ziel.",
    hero_sub: "AtoB Logistics GmbH bietet maßgeschneiderte und effiziente Logistiklösungen für den gesamten europäischen Raum.",
    hero_cta_rental: "Fahrzeug mieten",
    hero_cta_contact: "Jetzt anfragen",

    // Stats
    stat_experience: "Jahre Erfahrung",
    stat_transports: "Transporte/Jahr",
    stat_countries: "Länder",
    stat_punctuality: "Pünktlichkeit",

    // Services
    services_overline: "Unsere Leistungen",
    services_heading: "Was wir für Sie tun",
    service_1_title: "Zuverlässige Transporte",
    service_1_desc: "Pünktliche und sichere Lieferungen in ganz Europa. Vom Stückgut bis zur Komplettladung.",
    service_2_title: "Einfache Prozesse",
    service_2_desc: "Optimierte Abläufe, die Zeit und Kosten sparen. Digitale Auftragsabwicklung in Echtzeit.",
    service_3_title: "Erfahrenes Team",
    service_3_desc: "Unsere Fachleute verfügen über jahrelange Erfahrung in der Logistikbranche.",
    service_4_title: "Fahrzeugvermietung",
    service_4_desc: "LKW und Transporter für Ihren Bedarf. Flexible Mietzeiten, faire Preise.",
    service_more: "Mehr erfahren",

    // About
    about_overline: "Über uns",
    about_heading: "Ihr Partner für Logistik",
    about_text: "AtoB Logistic Solutions GmbH ist Ihr zuverlässiger Partner für Transporte in ganz Europa. Mit unserem erfahrenen Team und modernster Technologie sorgen wir dafür, dass Ihre Waren sicher und pünktlich ans Ziel kommen.",
    about_feat_1: "Europaweite Transporte",
    about_feat_2: "Versicherte Lieferungen",
    about_feat_3: "24/7 Erreichbarkeit",
    about_feat_4: "Eigene Fahrzeugflotte",

    // Rental CTA
    rental_cta_heading: "LKW oder Transporter mieten?",
    rental_cta_sub: "Einfach Fahrzeug auswählen, Wunschtermin angeben und sofort ein Angebot erhalten.",
    rental_cta_button: "Zur Fahrzeugvermietung",

    // Contact
    contact_overline: "Kontakt",
    contact_heading: "Kontakt aufnehmen",
    contact_text: "Haben Sie Fragen zu unseren Leistungen oder möchten ein individuelles Angebot? Kontaktieren Sie uns - wir freuen uns auf Ihre Nachricht.",
    contact_email_label: "E-Mail",
    contact_address_label: "Adresse",
    contact_name: "Name",
    contact_name_placeholder: "Ihr Name",
    contact_email: "E-Mail",
    contact_email_placeholder: "ihre@email.de",
    contact_message: "Nachricht",
    contact_message_placeholder: "Ihre Nachricht...",
    contact_submit: "Nachricht senden",
    contact_sending: "Wird gesendet...",
    contact_success: "Nachricht erfolgreich gesendet!",
    contact_error: "Fehler beim Senden der Nachricht",
    contact_validation: "Bitte alle Felder ausfüllen",

    // Footer
    footer_desc: "Maßgeschneiderte und effiziente Logistiklösungen für den gesamten europäischen Raum.",
    footer_nav: "Navigation",
    footer_contact: "Kontakt",
    footer_phone: "Auf Anfrage",
    footer_rights: "Alle Rechte vorbehalten.",
    footer_impressum: "Impressum",
    footer_datenschutz: "Datenschutz",

    // Rental Page
    rental_overline: "Fahrzeugvermietung",
    rental_heading: "LKW & Transporter mieten",
    rental_sub: "Wählen Sie Ihr Fahrzeug, geben Sie Ihren Wunschtermin an und erhalten Sie sofort ein Angebot. Einfach, schnell, transparent.",
    rental_step_1: "Fahrzeug wählen",
    rental_step_2: "Termin & Daten",
    rental_step_3: "Bestätigen",
    rental_filter_all: "Alle Fahrzeuge",
    rental_filter_lkw: "Sattelzugmaschinen",
    rental_filter_trans: "3,5t Transporter",
    rental_loading: "Fahrzeuge werden geladen...",
    rental_empty: "Keine Fahrzeuge verfügbar",
    rental_book: "Jetzt buchen",
    rental_per_day: "EUR/Tag",
    rental_info_1_title: "Sofort verfügbar",
    rental_info_1_desc: "Online Verfügbarkeit prüfen und direkt buchen",
    rental_info_2_title: "Faire Preise",
    rental_info_2_desc: "Transparente Tagespreise ohne versteckte Kosten",
    rental_info_3_title: "Zahlung vor Ort",
    rental_info_3_desc: "Bequem vor Ort oder auf Rechnung bezahlen",
    rental_error: "Fehler beim Laden der Fahrzeuge",

    // Booking Dialog
    booking_confirmed: "Buchung bestätigt",
    booking_thank_you: "Vielen Dank für Ihre Buchung",
    booking_step_date: "Zeitraum",
    booking_step_data: "Ihre Daten",
    booking_step_confirm: "Bestätigung",
    booking_select_period: "Miet-Zeitraum wählen",
    booking_your_data: "Ihre Kontaktdaten",
    booking_name: "Name",
    booking_name_placeholder: "Max Mustermann",
    booking_email: "E-Mail",
    booking_email_placeholder: "max@beispiel.de",
    booking_phone: "Telefon",
    booking_phone_placeholder: "+49 123 456789",
    booking_total: "Gesamtpreis",
    booking_payment_note: "Zahlung vor Ort oder auf Rechnung. Keine Online-Zahlung erforderlich.",
    booking_back: "Zurück",
    booking_next: "Weiter",
    booking_submit: "Verbindlich buchen",
    booking_submitting: "Wird gebucht...",
    booking_close: "Schließen",
    booking_success_title: "Buchung erfolgreich!",
    booking_success_text: "Wir haben Ihre Buchung erhalten und werden uns in Kürze bei Ihnen melden.",
    booking_nr: "Buchungs-Nr.",
    booking_vehicle: "Fahrzeug",
    booking_period: "Zeitraum",
    booking_days: "Tage",
    booking_day: "Tag",
    booking_date_error: "Bitte wählen Sie einen Zeitraum",
    booking_form_error: "Bitte alle Felder ausfüllen",
    booking_error: "Fehler bei der Buchung",
    booking_created: "Buchung erfolgreich erstellt!",
    booking_lkw: "LKW",
    booking_transporter: "Transporter",

    // Admin
    admin_title: "Admin Dashboard",
    admin_refresh: "Aktualisieren",
    admin_total: "Gesamt",
    admin_pending: "Ausstehend",
    admin_confirmed: "Bestätigt",
    admin_cancelled: "Storniert",
    admin_filter: "Buchungen filtern",
    admin_filter_all: "Alle Status",
    admin_col_nr: "Buchungs-Nr.",
    admin_col_vehicle: "Fahrzeug",
    admin_col_customer: "Kunde",
    admin_col_period: "Zeitraum",
    admin_col_price: "Preis",
    admin_col_status: "Status",
    admin_col_action: "Aktion",
    admin_details: "Details",
    admin_no_bookings: "Keine Buchungen vorhanden",
    admin_loading: "Buchungen werden geladen...",
    admin_detail_title: "Buchungsdetails",
    admin_detail_booking: "Buchung",
    admin_change_status: "Status ändern",
    admin_confirm: "Bestätigen",
    admin_cancel: "Stornieren",
    admin_reset: "Zurücksetzen",
    admin_status_updated: "Status aktualisiert",
    admin_status_error: "Fehler beim Aktualisieren des Status",
    admin_load_error: "Fehler beim Laden der Buchungen",
  },
  en: {
    // Navbar
    nav_home: "Home",
    nav_rental: "Vehicle Rental",
    nav_services: "Services",
    nav_contact: "Contact",
    nav_cta: "Rent now",

    // Hero
    hero_holding: "A company of",
    hero_badge: "Europe-wide \u00b7 Reliable \u00b7 Professional",
    hero_heading: "We deliver your goods on time.",
    hero_sub: "AtoB Logistics GmbH offers tailored and efficient logistics solutions across the entire European market.",
    hero_cta_rental: "Rent a vehicle",
    hero_cta_contact: "Get in touch",

    // Stats
    stat_experience: "Years of experience",
    stat_transports: "Transports/year",
    stat_countries: "Countries",
    stat_punctuality: "On-time rate",

    // Services
    services_overline: "Our Services",
    services_heading: "What we do for you",
    service_1_title: "Reliable Transport",
    service_1_desc: "Punctual and secure deliveries across Europe. From parcels to full truckloads.",
    service_2_title: "Simple Processes",
    service_2_desc: "Optimised workflows that save time and money. Real-time digital order processing.",
    service_3_title: "Experienced Team",
    service_3_desc: "Our specialists bring years of expertise in the logistics industry.",
    service_4_title: "Vehicle Rental",
    service_4_desc: "Trucks and vans for your needs. Flexible rental periods, fair prices.",
    service_more: "Learn more",

    // About
    about_overline: "About us",
    about_heading: "Your logistics partner",
    about_text: "AtoB Logistic Solutions GmbH is your reliable partner for transport across Europe. With our experienced team and cutting-edge technology, we ensure your goods arrive safely and on time.",
    about_feat_1: "Europe-wide transport",
    about_feat_2: "Insured deliveries",
    about_feat_3: "24/7 availability",
    about_feat_4: "Own vehicle fleet",

    // Rental CTA
    rental_cta_heading: "Need a truck or van?",
    rental_cta_sub: "Simply choose a vehicle, select your dates and receive an instant quote.",
    rental_cta_button: "Go to vehicle rental",

    // Contact
    contact_overline: "Contact",
    contact_heading: "Get in touch",
    contact_text: "Have questions about our services or need a custom quote? Contact us \u2013 we look forward to hearing from you.",
    contact_email_label: "Email",
    contact_address_label: "Address",
    contact_name: "Name",
    contact_name_placeholder: "Your name",
    contact_email: "Email",
    contact_email_placeholder: "your@email.com",
    contact_message: "Message",
    contact_message_placeholder: "Your message...",
    contact_submit: "Send message",
    contact_sending: "Sending...",
    contact_success: "Message sent successfully!",
    contact_error: "Failed to send message",
    contact_validation: "Please fill in all fields",

    // Footer
    footer_desc: "Tailored and efficient logistics solutions across the entire European market.",
    footer_nav: "Navigation",
    footer_contact: "Contact",
    footer_phone: "On request",
    footer_rights: "All rights reserved.",
    footer_impressum: "Legal notice",
    footer_datenschutz: "Privacy policy",

    // Rental Page
    rental_overline: "Vehicle Rental",
    rental_heading: "Rent trucks & vans",
    rental_sub: "Choose your vehicle, select your dates and receive an instant quote. Simple, fast, transparent.",
    rental_step_1: "Choose vehicle",
    rental_step_2: "Dates & details",
    rental_step_3: "Confirm",
    rental_filter_all: "All vehicles",
    rental_filter_lkw: "Semi-trucks",
    rental_filter_trans: "3.5t Vans",
    rental_loading: "Loading vehicles...",
    rental_empty: "No vehicles available",
    rental_book: "Book now",
    rental_per_day: "EUR/day",
    rental_info_1_title: "Instantly available",
    rental_info_1_desc: "Check availability online and book directly",
    rental_info_2_title: "Fair prices",
    rental_info_2_desc: "Transparent daily rates with no hidden costs",
    rental_info_3_title: "Pay on site",
    rental_info_3_desc: "Pay conveniently on site or by invoice",
    rental_error: "Failed to load vehicles",

    // Booking Dialog
    booking_confirmed: "Booking confirmed",
    booking_thank_you: "Thank you for your booking",
    booking_step_date: "Period",
    booking_step_data: "Your details",
    booking_step_confirm: "Confirmation",
    booking_select_period: "Select rental period",
    booking_your_data: "Your contact details",
    booking_name: "Name",
    booking_name_placeholder: "John Smith",
    booking_email: "Email",
    booking_email_placeholder: "john@example.com",
    booking_phone: "Phone",
    booking_phone_placeholder: "+49 123 456789",
    booking_total: "Total price",
    booking_payment_note: "Payment on site or by invoice. No online payment required.",
    booking_back: "Back",
    booking_next: "Next",
    booking_submit: "Confirm booking",
    booking_submitting: "Booking...",
    booking_close: "Close",
    booking_success_title: "Booking successful!",
    booking_success_text: "We have received your booking and will contact you shortly.",
    booking_nr: "Booking no.",
    booking_vehicle: "Vehicle",
    booking_period: "Period",
    booking_days: "days",
    booking_day: "day",
    booking_date_error: "Please select a period",
    booking_form_error: "Please fill in all fields",
    booking_error: "Booking failed",
    booking_created: "Booking created successfully!",
    booking_lkw: "Truck",
    booking_transporter: "Van",

    // Admin
    admin_title: "Admin Dashboard",
    admin_refresh: "Refresh",
    admin_total: "Total",
    admin_pending: "Pending",
    admin_confirmed: "Confirmed",
    admin_cancelled: "Cancelled",
    admin_filter: "Filter bookings",
    admin_filter_all: "All statuses",
    admin_col_nr: "Booking no.",
    admin_col_vehicle: "Vehicle",
    admin_col_customer: "Customer",
    admin_col_period: "Period",
    admin_col_price: "Price",
    admin_col_status: "Status",
    admin_col_action: "Action",
    admin_details: "Details",
    admin_no_bookings: "No bookings found",
    admin_loading: "Loading bookings...",
    admin_detail_title: "Booking details",
    admin_detail_booking: "Booking",
    admin_change_status: "Change status",
    admin_confirm: "Confirm",
    admin_cancel: "Cancel",
    admin_reset: "Reset",
    admin_status_updated: "Status updated",
    admin_status_error: "Failed to update status",
    admin_load_error: "Failed to load bookings",
  },
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState("de");

  const t = useCallback(
    (key) => translations[lang]?.[key] || translations.de[key] || key,
    [lang]
  );

  const toggleLang = useCallback(() => {
    setLang((prev) => (prev === "de" ? "en" : "de"));
  }, []);

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggleLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
}
